import { render, staticRenderFns } from "./points-reward-detail.vue?vue&type=template&id=53da571c&"
import script from "./points-reward-detail.vue?vue&type=script&lang=js&"
export * from "./points-reward-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports